module.exports = __webpack_public_path__ + "static/img/JOEL.e7c14b5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/JOEL.jpeg
// module id = W+ms
// module chunks = 0